import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import RecipePage from "../pages/recipe/RecipePage";
import RecipePreview from "./RecipePreview";
import { Checkbox, FormControlLabel } from "@mui/material";
import { MEALS } from "../constants/recipeConstants";
import { UPDATE_RECIPE } from "../constants/reducerEvents";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function Categorizer({ open, setOpen }) {
  const dispatch = useDispatch();
  const [categories, setCategories] = React.useState([]);
  const saveRecipe = () => {
    const newRecipe = { ...recipes[0], meal: categories };
    setCategories([]);
    dispatch({ type: UPDATE_RECIPE, payload: newRecipe });
  };
  const toggleCategory = (category) => {
    setCategories((c) =>
      c.includes(category) ? c.filter((k) => k !== category) : [...c, category]
    );
  };

  const recipes = useSelector((state) =>
    state.recipes.filter(
      (r) => !r.hasOwnProperty("meal") || r.meal.length === 0
    )
  );
  React.useEffect(() => {
    if (recipes.length === 0) {
      setOpen(false);
    }
  }, [recipes]);
  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {`Please Categorize Your ${recipes.length} New Recipes`}
        </Typography>
        <div style={{ display: "flex" }}>
          {recipes.length > 0 && <RecipePreview recipe={recipes[0]} disabled />}
          <div>
            {MEALS.map((m) => (
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={categories.includes(m)}
                      onChange={() => toggleCategory(m)}
                    />
                  }
                  label={m}
                />
              </div>
            ))}
            <div>
              <Button variant="contained" onClick={saveRecipe}>
                Save
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
